import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiGet, apiPost } from 'api-service';
import { urlAdapter } from './tinyUrl.adapters';

export const fetchUrls = createAsyncThunk(
  'tinyUrlReducer/fetchUrls',
  async (params = {}, thunkAPI) => {
    const { settingsReducer } = thunkAPI.getState();
    try {
      const response = await apiGet('/search/api/v1/short-url', {
        page: 1,
        count:
          settingsReducer?.filters?.public?.pageContentCountSlider
            ?.selectedValue,
        ...params,
      });

      return {
        urls: response.data?.result?.data?.map((url) => urlAdapter(url)),
        total: response.data?.result?.meta?.total,
      };
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const createTinyUrl = createAsyncThunk(
  'tinyUrlReducer/createTinyUrl',
  async (params = {}, thunkAPI) => {
    try {
      const response = await apiPost('/search/api/v1/short-url/make', params);
      await thunkAPI.dispatch(fetchUrls());
      return response.data?.result?.data?.short_url || '';
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
